const e164PhoneNumber = /^\+[1-9]\d{1,14}$/;

export const isValidE164PhoneNumber = (phoneNumber: unknown): phoneNumber is string =>
  typeof phoneNumber === "string" && e164PhoneNumber.test(phoneNumber);
